import React, { forwardRef } from "react";
import { Select } from "antd";

const WhatsAppRecapWarehouseSelect = forwardRef(function WhatsAppRecapWarehouseSelect(
  { value = [], onChange, warehouses = [], savedWarehouses = [], companyId, assignedIds = [], isGlobal = false, ...props },
  ref,
) {
  const allowed = new Map(warehouses
    .filter((warehouse) => Number(warehouse.company_id) === Number(companyId) &&
      warehouse.status === "active" && (isGlobal || assignedIds.map(Number).includes(Number(warehouse.id))))
    .map((warehouse) => [Number(warehouse.id), { value: Number(warehouse.id), label: warehouse.name }]));
  value.forEach((id) => {
    if (allowed.has(Number(id))) return;
    const saved = savedWarehouses.find((warehouse) => Number(warehouse.id) === Number(id));
    allowed.set(Number(id), { value: Number(id), label: `${saved?.name || `Établissement ${id}`} · à vérifier`, disabled: true });
  });
  return <Select
    {...props}
    ref={ref}
    allowClear
    mode="multiple"
    onChange={onChange}
    options={[...allowed.values()]}
    optionFilterProp="label"
    placeholder="Aucun bilan WhatsApp activé"
    style={{ width: "100%" }}
    value={value}
  />;
});

export default WhatsAppRecapWarehouseSelect;
